import authApi from '../../api/auth'
// import store from '../../store'
import { auth } from 'firebase/app'

export default [
	{ path: '/login', redirect: '/auth/login' },
	{
		path: "/auth",
		name: "auth",
		components: {
			appView: () => import("../../views/auth/TheLogin"),
		},
		beforeEnter: (to, from, next) => {
			const { currentUser } = auth()
			if (!currentUser) {
				if (to.path === '/auth/login' && process.env.VUE_APP_COMPANY_LOGIN) {
					return next({ name: "LoginAsTenantWithCompany", params: { name: process.env.VUE_APP_COMPANY_LOGIN } })
				}
				next()
			} else {
				next('/home')
			}
		},
		meta: {
			title: "login.title"
		},
		children: [
			{
				path: "login",
				name: "Login",
				component: () => import("../../views/auth/TheLoginForm")
			},
			{
				path: "company",
				name: "LoginAsTenant",
				component: () => import("../../views/auth/TheTenantLoginForm")
			},
			{
				path: "company/:name",
				name: "LoginAsTenantWithCompany",
				component: () => import("../../views/auth/TheTenantLoginForm"),
				props: true,
			},
			{
				path: "forgot-password",
				name: "ForgotPassword",
				component: () => import("../../views/auth/TheForgotPassword")
			},
			{
				path: "manage-company",
				name: "ManageCompany",
				component: () => import("../../views/auth/TheManageCompanyForm")
			},
			{
				path: "recover-password/:token",
				name: "RecoverPassword",
				component: () => import("../../views/auth/TheRecoverPassword"),
				beforeEnter: async (to, from, next) => {
					const token = to.params.token
					try {
						await authApi.checkRecoverPasswordToken(token)
						next()
					} catch (e) {
						next({ name: "Login" });
					}
				}
			},
		]
	},
	{
		path: '/logout',
		name: 'Logout',
		components: {
			appView: () => import("../../views/auth/TheLogout")
		}
	},
	{
		path: "/loading",
		name: "Loading",
		components: {
			appView: () => import("../../views/auth/TheLoading")
		},
		meta: {
			title: "login.loading"
		}
	},
	{
		path: "/redirect",
		components: {
			appView: () => import("../../views/TheRedirect")
		}
	}
]
